import { getStudyTypeMeta, isKnownStudyGoal } from "@/features/studies/studyTypeMeta";
import { cn } from "@/lib/utils";

import { eyebrowIconClass, eyebrowItemClass, studyTypeIcon } from "./eyebrowMeta";

export interface StudyTypePillProps {
  goalId?: string | null;
  className?: string;
}

/**
 * Report hero fact for the study's method tag (the same wording as the lobby
 * card, e.g. "Ad Testing"), with that study type's icon. Renders nothing for
 * a null or unrecognized `goalId`: unlike the lobby, the hero never falls
 * back to a "Custom" label.
 */
export function StudyTypePill(props: StudyTypePillProps) {
  const { goalId, className } = props;

  if (!goalId || !isKnownStudyGoal(goalId)) {
    return null;
  }

  const { label } = getStudyTypeMeta(goalId);
  const icon = studyTypeIcon(goalId);
  const StudyIcon = icon?.Icon;

  return (
    <span
      data-testid="report-study-type-pill"
      className={cn(eyebrowItemClass, "whitespace-nowrap", className)}
    >
      {StudyIcon && icon && (
        <StudyIcon
          className={eyebrowIconClass}
          aria-hidden="true"
          data-testid="report-study-type-icon"
          data-icon={icon.name}
        />
      )}
      {label}
    </span>
  );
}
